<template>

<transition name="component-fade" mode="out-in">
  <div class="col-md-12" style="padding-left:30px;margin-top:30px;">
    <div class="row" style="margin-top:30px;">
      <div v-for="l in levels" :key="l" class="col-md-2 level-btn" v-if="l !== currentLevel">
        <router-link :to="{path:`/Cortina/${l}`}">
          {{l}}
        </router-link>
      </div>
      <div class="col-md-2 level-btn" v-else style="background-color:#d9272e;">
        <router-link :to="{path:`/Cortina/${l}`}">
          {{l}}
        </router-link>
      </div>
    </div>
    <br>
    <div class="row" style="margin-top:30px;width:98%">


      <div v-for="c in Categories" :key="c" class="col-md-6" >
        <div class="category-btn" @click="loadMaterial(`${c}`)" v-if="c != currentCategory">
          {{c}}
        </div>
          <div class="category-btn active" @click="loadMaterial(`${c}`)" v-else>
            {{c}}
          </div>
      </div>

    </div>
        <div class="cleanup" v-for="(i,index) in Favourites" :key="index" @click="cleanup(`${i}`)">CLEAN UP</div>
    <div class="row showpad" style="margin-top:30px;">
     <transition-group name="list" tag="div">
      <div v-for="(i,index) in Items" :key="index" class="list-item">
        <div class="col-md-4 info">
          <img :src="getImage(`${i.Image}`)" class="img-responsive">
          <br>
          <br>
          <p>{{i.Categorys}}</p>
          <p>{{i.Code}}</p>
          <p>{{i.Name}}</p>
          <p>{{i.Category}}</p>
          <p>{{i.Level}}</p> 
          <div v-if="currentCategory !='VIEW FAVOURITES'">
          <button class="fav-collection-btn" :class="{'disable': isInFavorites(i.id)}" @click="addFavourite(i)">ADD TO FAVOURITES</button>
          </div>
          <div v-if="currentCategory =='VIEW FAVOURITES'">
          <button class="fav-collection-btn" @click="removeFavourite(index)">REMOVE</button>
          </div>
        </div>
      </div>
     </transition-group>
    </div>
  </div>
  </transition>
</template>

<script>
  import Material from '../../static/deco-touchscreen-export.json'
  import _ from 'lodash'
  // import uniq from 'lodash/uniq'
  export default {
    name: 'Material',
    props: ['level'],
    data() {
      return {
        msg: 'Material',
        Materials: Material,
        levels: [],
        currentLevel: '',
        currentCategory: 'VIEW ALL',
        Categories: [],
        Items: [],
        Favourites: []
      }
    },
  
    created: function() {
      this.fetchData();
    },
    methods: {
      isInFavorites(id){

        for (const key in this.Favourites) {
          if (this.Favourites.hasOwnProperty(key)) {
            const element = this.Favourites[key];

            
            if(element.id === id){
              console.log('match found', element.id, id);
              return true;
            }
          }
        }

        return false;
      },
      getLevel: function(e) {
        this.new = null;
        this.new = Material;
        var i = 0;
        var newLevel = [];
        for (i == 0; i < (this.new).length; i++) {
          if ((this.new)[i].Brand == 'Cortina') {
            newLevel.push((this.new)[i].Level)
          }
        }
        this.levels = _.uniq(newLevel);
      },
      getCategories: function(e) {
        var i = 0;
        var newCategories = [];
        for (i == 0; i < Material.length; i++) {
          if (Material[i].Brand == 'Cortina' && Material[i].Level == e) {
            newCategories.push('VIEW ALL')
            newCategories.push('VIEW FAVOURITES')
            newCategories.push(Material[i].Category)
          }
        }
        this.Categories = _.uniq(newCategories);
      },
      loadMaterial: function(e) {
        
        this.currentCategory = e;
        var i = 0;
        var newItem = [];
        for (i == 0; i < Material.length; i++) {
          if (e == 'VIEW ALL') {
            if (Material[i].Brand == 'Cortina' && Material[i].Level == this.currentLevel) {
              newItem.push(Material[i]);
               $('.cleanup').fadeOut();
            }
          }
          if (e == 'VIEW FAVOURITES') {
            newItem = this.Favourites;
             $('.cleanup').fadeIn();
          }else {
            if (Material[i].Brand == 'Cortina' && Material[i].Level == this.currentLevel && Material[i].Category == e) {
              newItem.push(Material[i]);
               $('.cleanup').fadeOut();
            }
          }
        }
        this.Items = newItem;
      },
      addFavourite:function(e){
            this.Favourites.push(e);
            this.Favourites =_.uniq(this.Favourites);
      },
      removeFavourite:function(index){
        this.Favourites.splice(index, 1);
      },
      getImage(url) {
        return require('../../static/materials/' + url);
      },
          cleanup:function(i){
          this.Favourites.splice(i);
      },
      fetchData() {
        this.error = this.post = null;
        this.currentLevel = this.$route.params.level;
        this.getCategories(this.currentLevel);
        this.loadMaterial('VIEW ALL');
  
      }
    },
    watch: {
      // call again the method if the route changes
      $route: "fetchData"
    },
    mounted() {
      this.getLevel();
      
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1 {
    color: #d9272e;
    font-size: 80px;
    margin-top: 83%;
  }
  h2 {
    font-family: 'ralewaysemibold';
    font-size: 40px;
    font-style: italic;
    line-height: 50px;
    margin: 70px;
  }
  h3 {
    color: #d9272e;
    font-size: 40pt;
    font-weight: 100;
  }
  a {
    color: #ffffff;
    font-family: 'ralewaysemibold';
    font-size: 20px;
  }
  .col-md-6 {
    padding: 5px;
  }
  .col-md-12 {
    padding: 5px;
  }
  .row {
    margin-left: -2px;
  }

.disable{
  background-color:darkgrey;
  color: #858585;
  transition:all 0.3s;
}

.col-md-2 {
    width: 18%;
}

</style>



// WEBPACK FOOTER //
// src/components/Materials.vue